import React from 'react';
import {
  List,
  Create,
  SimpleForm,
  AutocompleteInput,
  ReferenceInput,
  DateInput,
  FunctionField,
  ReferenceArrayInput,
  // CheckboxGroupInput,
  SelectInput,
  TextField,
  translate as t,
  Datagrid,
  // Toolbar,
  // SaveButton,
  DateField,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import DeleteButton from '../components/button/DeleteButton';
import EditButton from '../components/button/EditButton';
import TranslatableField from '../components/fields/TranslatableField';
import { ChipRender } from '../components/fields/ChipArrayField';
import SelectArrayInput from '../components/inputs/SelectArrayInput';

export const PromotedProductList = (props) => (
  <List {...props} pagination={null} perPage={9999}>
    <Datagrid>
      <TextField source="product.internalName" />
      <FunctionField label="Promoted in" render={(record) => ChipRender(record)} />
      <DateField source="start" />
      <DateField source="end" />
      <DeleteButton {...props} basePath="/promoted-products" />
      <EditButton {...props} basePath="/promoted-products" />
    </Datagrid>
  </List>
);

const Form = (props) => (
  <SimpleForm {...props}>
    <SelectInput
      source="type"
      choices={[
        { id: 'app', name: 'In-App (menu)' },
        { id: 'editorial', name: 'Editorial (Old)' },
        { id: 'editorial-carousel-1', name: 'Editorial Carousel 1' },
        { id: 'editorial-carousel-1-kids', name: 'Editorial Carousel 1 Kids' },
        { id: 'editorial-carousel-2', name: 'Editorial Carousel 2' },
        { id: 'editorial-carousel-2-kids', name: 'Editorial Carousel 2 Kids' },
        { id: 'editorial-carousel-3', name: 'Editorial Carousel 3' },
        { id: 'editorial-carousel-3-kids', name: 'Editorial Carousel 3 Kids' },
        { id: 'web', name: 'Website' },
      ]}
    />
    <ReferenceInput
      {...props}
      source="productCode"
      reference="products"
      allowEmpty
      filter={{ provisional: { $ne: true }, frozen: { $ne: true } }}
    >
      <AutocompleteInput
        optionText="internalName"
        options={{ fullWidth: true }}
      />
    </ReferenceInput>
    <ReferenceArrayInput
      {...props}
      source="venueNames"
      reference="venues"
      filter={
        props.user && props.user.superUser
          ? {}
          : { name: { $in: props.user.venues } }
      }
      allowEmpty
    >
      <SelectArrayInput optionText="name" options={{ fullWidth: true }} />
    </ReferenceArrayInput>
    {props.user && props.user.superUser && (
      <ReferenceArrayInput
        {...props}
        source="markets"
        reference="markets"
        allowEmpty
      >
        <SelectArrayInput
          optionText="countryCode"
          options={{ fullWidth: true }}
        />
      </ReferenceArrayInput>
    )}
    <ReferenceInput
      {...props}
      format={(category) => category && category._id}
      source="category"
      reference="categories"
      allowEmpty
    >
      <SelectInput optionText={<Title {...props} />} />
    </ReferenceInput>
    <DateInput source="start" />
    <DateInput source="end" />
  </SimpleForm>
);

export const PromotedProductCreate = (props) => (
  <Create {...props}>
    <Form {...props} />
  </Create>
);

const Title = t(({ record, locale }) => (getTranslationByLocale(record.title, locale)));

export const PromotedProductEdit = (props) => (
  <Edit {...props} title={<TranslatableField source="title" />}>
    <Form {...props} />
  </Edit>
);
